import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@ecom/ui/card';

export const Route = createFileRoute('/(app)/settings/')({
  component: SettingsPage,
});

function SettingsPage() {
  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold">Settings</h1>
      <Card>
        <CardHeader>
          <CardTitle>Organization</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Manage members, billing, and integrations.
        </CardContent>
      </Card>
    </div>
  );
}
